import { useQuery } from '@tanstack/react-query';
import { fetchSourceMarkets } from './source-markets.api';

export const SOURCE_MARKETS_QUERY_KEY = ['source-markets'] as const;

const STALE_TIME_MS = 1000 * 60 * 10;
const GC_TIME_MS = 1000 * 60 * 30;

export function useSourceMarketsQuery() {
  return useQuery({
    queryKey: SOURCE_MARKETS_QUERY_KEY,
    queryFn: fetchSourceMarkets,
    staleTime: STALE_TIME_MS,
    gcTime: GC_TIME_MS,
  });
}
